import _ from 'underscore';
import GenericModel from 'js/models/generic.model';
import moment from 'moment';
import i18n from 'l10n';

const {Backbone} = require('backboneAdapter');
require('metroHelpers');

export default GenericModel.extend({
    urlRoot: '/CampaignCloud/Group',
    url: function () {
        const id = this.get("id");
        return id ? `${this.urlRoot}/${id}` : this.urlRoot;
    },
    idAttribute: 'id',
    defaults: {
        id: null,
        generationDate: moment(),
        size: 0,
        title: "",
        description: "",
        groupType: '',
        planType: null,
        user: null,
        qualifiedGroupStatus: null,
        subscriptionType: null,
        serviceType: null,
        blockedCount: 0,
        emailBounced: 0,
        smsBounced: 0
    },
    myName: function () {
        if (!this.get("title")) {
            return "Untitled";
        }
        return this.get("title");
    },
    myText: function () {
        const s = _.reduce([this.get("title")],
            function (memo, v) {
                return v ? `${memo} ${v}` : memo;
            },
            '');
        return s.toLowerCase();
    },
    getSubscribersCollectionUrl: function () {
        if (this.get("groupType") === "enum") {
            return `${this.url()}/items`;
        } else { //query
            return `/CampaignCloud/Subscription/ByCriterion?criterion=${encodeURIComponent(this.get("query"))}`;
        }
    },
    addContactToGroup: function (id, description, email) {
        $.ajaxDefaultQ({
            url: `${this.getSubscribersCollectionUrl()}/${id}`,
            type: 'PUT',
            dataType: 'json'
        }).done(data => {
            if (data.outcome === "OK") {
                this.fetch();
                this.trigger("blockedChanged");
                $.Notify.show(i18n.t("groups.contactaddedsuccessfully"));
            } else if (!email && description === 'BOUNCED EMAILS') {
                $.Notify.error(i18n.t("group.contactHasNoEmail"));
            } else {
                $.Notify.error(`${i18n.t("groups.contactingroup")}.`);
            }
        }).fail(data => $.Notify.error(`${i18n.t("groups.putfailed")} = ${data.status ? data.status : ""}`));
    },
    removeContactFromGroup: function (sid) {
        const self = this;
        const gid = this.get(this.idAttribute);
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Subscription/${sid}/Groups/${gid}/remove`,
            type: 'DELETE',
            dataType: 'json'
        }).done(function (data) {
            if (data.outcome === "OK") {
                self.fetch();
            } else {
                $.Notify.error(i18n.t("groups.contactnotingroup") + '.');
            }
        }).fail(function (data) {
            $.Notify.error(i18n.t("groups.putfailed") + ' = ' + (data.status ? data.status : ""));
        });
    }
});
